import { TableColumn } from 'types/types'
import { TableActionConfig } from 'components/Table/types'
import { TableActions } from 'components/Table/TableActions'

export const deviceSNTableColumns = <T,>({
  actions,
}: {
  actions: TableActionConfig<T>[]
}): TableColumn[] => [
  { id: 'serial_number', label: 'Serial Number', minWidth: 170 },

  {
    id: 'instrument_type',
    label: 'Device Type',
    minWidth: 170,
    format: (value: any) =>
      value ? `${value.name} (${value.manufacturer})` : '-',
  },

  {
    id: 'is_active',
    label: 'Status',
    minWidth: 100,
    format: (value: boolean) => {
      const color = value ? '#4caf50' : '#ff9800'
      return (
        <span
          style={{
            color,
            fontWeight: 'bold',
            padding: '4px 8px',
            borderRadius: '4px',
            backgroundColor: `${color}15`,
          }}
        >
          {value ? 'Active' : 'Inactive'}
        </span>
      )
    },
  },

  {
    id: 'actions',
    label: '',
    minWidth: 100,
    align: 'right',
    format: (_, row: T) => <TableActions actions={actions} row={row} />,
  },
]
